// extracted by mini-css-extract-plugin
export default {"iconFill":"CardIcon_iconFill__OTJkZ","iconWrapper":"CardIcon_iconWrapper__MmE1M","logoImageRedesign":"CardIcon_logoImageRedesign__MzIxZ"};